import Paragraphe from "./Paragraphe";

class ParagrapheLister extends Paragraphe {
    components = [];

    constructor(title, components) {
        super('lister', title);
        if (components !== undefined) {
            this.components = components;
        }
    }
}

export default ParagrapheLister;